// Translation: Reset > Landing > Form (Turkish)
export default Object.freeze({
	form: {
		actions: {
			changePassword: 'Şifre değiştir',
			continue: 'Devam et'
		},
		fields: {
			code: {
				placeholder: 'Kodu girin'
			},
			email: {
				placeholder: 'E-postanızı girin'
			},
			password: {
				options: {
					hide: {
						label: 'Şifreyi gizle'
					},
					show: {
						label: 'Şifreyi göster'
					}
				},
				placeholder: 'Yeni şifre gir'
			},
			passwordConfirmation: {
				placeholder: 'Yeni şifreyi tekrar gir'
			}
		},
		options: {
			resendCode: {
				label: {
					idle: 'Kodu tekrar gönder',
					success: 'Kod gönderildi!'
				}
			}
		},
		title: {
			codeVerification: 'Kod doğrulama',
			information: 'Bilgiler',
			passwordReset: 'Şifre sıfırlama'
		}
	}
})
